import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useFormatMessage } from "../../helpers";
import { getYearPartInfo } from "../../helpers/yearPartHelpers";

export const YearParts = () => {
  const fm = useFormatMessage();
  let message = undefined;

  const flags = useFlags();
  const { mctCurrentPlanYear } = flags;
  const {
    isOpenEnrollment,
    isPublicPreview,
    isOpenEnrollmentNextYearOnly,
  } = getYearPartInfo(flags);

  if (isOpenEnrollment || isOpenEnrollmentNextYearOnly) {
    message = fm(
      { id: "landing_page.year_parts.during_oe" },
      { year: mctCurrentPlanYear + 1 }
    );
  } else if (isPublicPreview) {
    message = fm(
      { id: "landing_page.year_parts.public_preview" },
      { year: mctCurrentPlanYear + 1 }
    );
  }
  if (message) {
    return (
      <div className="mct-c-year-parts">
        <p
          className="mct-c-year-parts__content"
          data-testid="year-parts-message"
          data-cy="year-parts-message"
        >
          {message}
        </p>
      </div>
    );
  } else {
    return null;
  }
};
